module.exports = __webpack_public_path__ + "static/img/zcfg.4b532c7b.png";